(function () {
  'use strict';

  angular
      .module('tfc.retailer.StandardReports')
      .controller('ComparisonsHierarchyCtrl', ComparisonsHierarchyCtrl);

  // @ngInject
  function ComparisonsHierarchyCtrl($q, $state, $stateParams, storeKeys, filters, StandardReports, ConsumerChart,
                                    AreaLineChartConfig, Comparisons, Filters, PageConfig) {
    var vm = this;

    var detailLevel = filters.pathParams.detailLevel;
    var queryFilters = _.merge(filters.queryParams, {storeKey: storeKeys});

    vm.comparisonTab = $stateParams.comparisonTab || 0;
    vm.dateRange = {startDate: filters.queryParams.startDate, endDate: filters.queryParams.endDate};

    vm.metrics = Comparisons.metrics(PageConfig.hierarchyComparison);
    vm.selectedMetric = _.find(vm.metrics, function (metric) {
      return _.eq(metric.section.name, $stateParams.comparisonMetric);
    }) || _.head(vm.metrics);

    vm.hierarchies = Comparisons.hierarchies(filters.queryParams);
    vm.filter = Filters.getFilter();
    vm.comparisonFilter = Filters.getFilter();
    vm.comparisonFilter.addressable = vm.hierarchies[1].value.addressable;

    var groupNames = _.map(vm.hierarchies, function (hierarchy) {
      return hierarchy.name();
    });

    var optionsFunc = Comparisons.options(detailLevel, groupNames, Comparisons.hierarchyCompareTooltipHeader(groupNames));

    vm.reload = function() {
      var formattedDateRange = Comparisons.formatDateRange(vm.dateRange);

      $state.go('.', _.merge(formattedDateRange, { metric: vm.selectedMetric.section.name,
        department: vm.hierarchies[0].value.department, category: vm.hierarchies[0].value.category,
        classification: vm.hierarchies[0].value.classification, addressable: vm.filter.addressable,
        comparisonDepartment: vm.hierarchies[1].value.department,
        comparisonCategory: vm.hierarchies[1].value.category,
        comparisonClassification: vm.hierarchies[1].value.classification,
        comparisonAddressable: vm.comparisonFilter.addressable || false,
        comparisonTab: vm.comparisonTab }));
    };

    vm.displayComparison = function () {
      updateFilter(vm.hierarchies[1], vm.selectedMetric.section.name, vm.comparisonTab);

      vm.chartOptions = AreaLineChartConfig.getChartOptions(optionsFunc(vm.selectedMetric.section, vm.chartOptions));
    };

    vm.getData = function(selectedMetric) {
      var comparisonResponses = _.map(vm.hierarchies, function (hierarchy) {
        var api = selectedMetric.section.api;
        return StandardReports.getConsumerData(api, detailLevel,
            _.merge({}, queryFilters, Comparisons.formatDateRange(vm.dateRange), hierarchy.value));
      });

      return $q.all(comparisonResponses).then( function (responses) {
        return _.map(responses, function (response) {
          var data = selectedMetric.transformFunc(response);
          var formattedData = ConsumerChart.getFormattedData(selectedMetric.section.chart, data.dateMetrics);
          return {
            lineData: formattedData,
            summary: data.summary
          }
        });
      });
    };

    vm.dataOptions = function (formattedData) {
      return AreaLineChartConfig.getDataOptions(_.map(formattedData, 'lineData'),
          optionsFunc(vm.selectedMetric.section, vm.chartOptions));
    };

    vm.setParentValues = function (formattedData) {
      vm.summaryValues = Comparisons.getSummaryValues(_.map(formattedData, 'summary'),
          vm.selectedMetric.section, vm.hierarchies);
    };

    vm.onTabChange = function(selectedTabIndex) {
      vm.comparisonTab = selectedTabIndex;
      updateFilter(vm.hierarchies[1], vm.selectedMetric.section.name, vm.comparisonTab);
    };

    function defaultDataFunc() {
      return $q.resolve(vm.hierarchies);
    }

    $q.all(Comparisons.allMetricSummary(vm.metrics, defaultDataFunc, vm.hierarchies)).then(function (allMetricSections) {
      vm.allMetricSections = allMetricSections;

      var allMetrics = Comparisons.allMetricSummary(vm.metrics, vm.getData, vm.hierarchies);

      $q.all(allMetrics).then(function (allMetricSections) {
        vm.allMetricSections = allMetricSections;
      });
    });

    function updateFilter(comparisonHierarchy, selectedMetric, comparisonTab) {
      var filters = Filters.getFilter();

      filters.dashboardSpecificParams = {
        comparisonDepartment: comparisonHierarchy.value.department,
        comparisonCategory: comparisonHierarchy.value.category,
        comparisonClassification: comparisonHierarchy.value.classification,
        comparisonAddressable: comparisonHierarchy.value.addressable || false,
        comparisonMetric: selectedMetric,
        comparisonTab: comparisonTab
      };

      Filters.setFilter(filters);
    }

    vm.displayComparison();
  }
  })();
